import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  sideBar: true,
};

const loadingSlice = createSlice({
  name: "loading",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state[`loading`] = action.payload;
    },
    setSideBar: (state, action) => {
      console.log("🚀 ~ action:", action);
      state.sideBar = action.payload;
    },
  },
});

export const { setLoading, setSideBar } = loadingSlice.actions;

export default loadingSlice.reducer;
